import { render, staticRenderFns } from "./DadosComplementoComplemento.vue?vue&type=template&id=20a30dee&"
import script from "./DadosComplementoComplemento.vue?vue&type=script&lang=ts&"
export * from "./DadosComplementoComplemento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
